var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09815 33.124L0 0.0620728L37 0.128513L33.724 33.124L18.6396 36.9379L3.09815 33.124Z",
    fill: "url(#paint0_angular_32_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6396 33.7449V3.21082L33.8765 3.25511L31.1594 30.574L18.6396 33.7449Z",
    fill: "url(#paint1_angular_32_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0926 7.11365H6.65344L7.28841 11.1048H18.4111L7.46625 15.2072L8.10092 19.0654H24.2267L23.6424 24.4536L18.1825 25.3851L13.2308 24.2764L12.8497 21.2163H8.30412L8.91343 27.5805L18.665 29.9531L28.0105 27.3588L29.204 14.9187H19.325L30.0923 11.0162L30.0926 7.11365Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_32_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5 18.5) rotate(90) scale(18.4379 18.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "white",
    stopOpacity: 0.682292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.719051
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_32_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2581 18.4778) rotate(90) scale(15.267 7.61842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "white",
    stopOpacity: 0.682292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.719051
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.e37dec0a968f0ee799806fd92eb05321.svg";
export { ForwardRef as ReactComponent };